import React, { Component } from 'react';
import styled from 'styled-components';
import {
  StyledInputs,
  PasswordMatchError,
} from '../../HomePage/EsperSignUpFormComponent';
import { CountrySelect } from '@atlaskit/select';

const PhoneInput = styled.div`
  grid-column: span 1;
  margin-top: -6px;
  width: 100%;
  /* margin-left: 15px; */
  @media (max-width: 768px) {
    margin-left: 15px;
    width: unset;
  }
`;

interface PhoneInputProps {
  handleFocusContact: any;
  handleContactChange: any;
  validateContactNumber: any;
  handleCountrySelect: any;

  defaultCountry: any;
  contactNumber: any;
  contactError: any;
  submitError: any;
  messages: any;
}
export default class PhoneInputClass extends Component<PhoneInputProps> {
  render() {
    return (
      <div
        style={{ display: 'grid' }}
        onMouseDown={this.props.handleFocusContact}
      >
        {/*<Label
                style={{
                gridColumn: 'span 2',
                marginBottom: '10px',
              }}
            >
                Contact Number
            </Label>*/}
        <CountrySelect
          value={this.props.defaultCountry}
          onChange={this.props.handleCountrySelect}
          placeholder="Country"
        />
        <PhoneInput>
          <StyledInputs
            id="contact"
            value={this.props.contactNumber}
            aria-label="Contact"
            style={
              this.props.contactError
                ? {
                    boxShadow: '0 0 0 0.1rem #fd7e7ec7',
                    borderRadius: '4px',
                    marginTop: '6px',
                  }
                : { boxShadow: 'unset', marginTop: '6px' }
            }
            maxLength={149}
            onChange={this.props.handleContactChange}
            onBlur={this.props.validateContactNumber}
            onFocus={this.props.handleFocusContact}
            error={this.props.contactError || this.props.submitError}
            type="text"
            name="contact"
            placeholder={
              this.props.messages?.PricingPageContactUsFormContactNumber
            }
          />
        </PhoneInput>
        <PasswordMatchError style={{ gridColumn: 'span 2' }} id="contact-error">
          {this.props.contactError === false && this.props.submitError ? (
            <>
              <i className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
              {this.props.messages?.AllFormValidationMessagesValidPhoneNumber}
            </>
          ) : (
            this.props.contactError && (
              <>
                {' '}
                <i
                  className="fa fa-exclamation-triangle"
                  aria-hidden="true"
                />{' '}
                {this.props.contactNumber.length > 1
                  ? this.props.messages
                      ?.AllFormValidationMessagesValidPhoneNumber
                  : this.props.messages?.AllFormValidationMessagesPhoneNumber}
              </>
            )
          )}
        </PasswordMatchError>
      </div>
    );
  }
}
